var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3477 9.59126C15.762 10.1771 14.8122 10.1771 14.2264 9.59126L13.3503 8.71513L17.2239 4.84155C19.898 2.16741 24.2337 2.16741 26.9078 4.84156C29.582 7.5157 29.582 11.8514 26.9078 14.5255L23.0342 18.3991C20.3601 21.0732 16.0244 21.0732 13.3503 18.3991L14.2264 17.523C14.8122 16.9372 15.759 16.9712 16.5154 17.3091C18.0252 17.9835 19.8585 17.7012 21.0975 16.4623L24.971 12.5887C26.5755 10.9842 26.5755 8.38283 24.971 6.77834C23.3665 5.17386 20.7652 5.17386 19.1607 6.77834L16.3477 9.59126ZM10.9008 15.537L7.02719 19.4106C5.4227 21.0151 5.42271 23.6165 7.02719 25.221C8.63168 26.8255 11.2331 26.8255 12.8376 25.221L15.6505 22.4081C16.2363 21.8223 17.186 21.8223 17.7718 22.4081L18.6479 23.2842L14.7744 27.1578C12.1002 29.8319 7.76455 29.8319 5.0904 27.1578C2.41626 24.4836 2.41626 20.148 5.0904 17.4738L8.96398 13.6003C11.6381 10.9261 15.9738 10.9261 18.6479 13.6003L17.7718 14.4764C17.186 15.0622 16.2392 15.0281 15.4829 14.6903C13.9731 14.0158 12.1397 14.2981 10.9008 15.537Z",
    fill: "#8E9193"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.350521e7.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3477 9.59126C15.762 10.1771 14.8122 10.1771 14.2264 9.59126L13.3503 8.71513L17.2239 4.84155C19.898 2.16741 24.2337 2.16741 26.9078 4.84156C29.582 7.5157 29.582 11.8514 26.9078 14.5255L23.0342 18.3991C20.3601 21.0732 16.0244 21.0732 13.3503 18.3991L14.2264 17.523C14.8122 16.9372 15.759 16.9712 16.5154 17.3091C18.0252 17.9835 19.8585 17.7012 21.0975 16.4623L24.971 12.5887C26.5755 10.9842 26.5755 8.38283 24.971 6.77834C23.3665 5.17386 20.7652 5.17386 19.1607 6.77834L16.3477 9.59126ZM10.9008 15.537L7.02719 19.4106C5.4227 21.0151 5.42271 23.6165 7.02719 25.221C8.63168 26.8255 11.2331 26.8255 12.8376 25.221L15.6505 22.4081C16.2363 21.8223 17.186 21.8223 17.7718 22.4081L18.6479 23.2842L14.7744 27.1578C12.1002 29.8319 7.76455 29.8319 5.0904 27.1578C2.41626 24.4836 2.41626 20.148 5.0904 17.4738L8.96398 13.6003C11.6381 10.9261 15.9738 10.9261 18.6479 13.6003L17.7718 14.4764C17.186 15.0622 16.2392 15.0281 15.4829 14.6903C13.9731 14.0158 12.1397 14.2981 10.9008 15.537Z",
    fill: "#8E9193"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.350521e7.svg";
export { ForwardRef as ReactComponent };